import { CALL_API } from 'redux-api-middleware'
import { get, post, put, destroy } from 'utils/network'

export const fetchAssignedScholarships = () => {
  const request = get('/scholarships')
  request.types = ['SCSCHOL_REQ', 'SCSCHOL_GET_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const searchScholarship = (search) => {
  const request = get('/scholarships/search', {q: search, by: 'code'})
  request.types = ['SCHOL_Q_REQ', 'SCHOL_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const assignScholarship = (payload) => {
  let request = null
  if (payload.get('id')) {
    // UPDATE
    request = put('/scholarships/' + payload.get('id'), payload)
  } else {
    request = post('/scholarships', payload)
  }
  request.types = ['SCSCHOL_REQ', 'SCSCHOL_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const deleteAssignedScholarship = (id) => {
  const request = destroy('/scholarships/' + id)
  request.types = ['SCSCHOL_REQ', 'SCSCHOL_DEL_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Setup/Scholarships/actions.js